import { FC } from 'react';
import classes from './ReportListItem.tailwind';

interface IReportListItemProps {
  title: string;
  value?: string;
  'data-id'?: string;
}

export const ReportListItem: FC<IReportListItemProps> = ({ title, value, 'data-id': dataId, ...rest }) => {
  return (
    <li className={classes.listItemStyle} data-id={dataId} {...rest}>
      <span className={classes.titleStyle} data-id={`${dataId}-label`}>
        {title}
      </span>
      <span className={classes.valueStyle} data-id={`${dataId}-value`}>
        {value}
      </span>
    </li>
  );
};
